export function isOwnDeploy(deploy, profile) {
  if (!profile) return false;
  const req = deploy?.requestedBy;
  if (!req) return false;
  if (profile.id != null && req.id != null && String(req.id) === String(profile.id)) return true;
  if (profile.email && req.email && String(req.email).toLowerCase() === String(profile.email).toLowerCase()) return true;
  if (profile.userName && req.userName && String(req.userName).toLowerCase() === String(profile.userName).toLowerCase()) return true;
  return false;
}

export function canViewAllDeployments(profile) {
  if (!profile) return false;
  return !!profile.isAdministrator || !!profile.canViewAllDeployments;
}

export function canInteractWithDeploy(deploy, profile) {
  if (!profile) return false;
  if (profile.isAdministrator) return true;
  return isOwnDeploy(deploy, profile);
}
